module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/7_2-ed819b9f5327567f079e4ef570acc202.png";